import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPSEARCHPARAMETERSMODAL_LEGACY_FIELD_ORDER = [
  "display_asap_for_later_picker"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopSearchParametersModalDescriptor: _generatedShopSearchParametersModalDescriptor,
  shopSearchParametersModalModalDefinition,
  shopSearchParametersModalDashboardLayout,
  shopSearchParametersModalConfig,
  shopSearchParametersModalResolveConfig,
  shopSearchParametersModalProperties,
} = doodModalConfig(
  {
    name: "Shop search parameter modal",
    handle: "shop-search-parameters-modal",
    internal_name: "ShopSearchParametersModal",
    componentType: 'ShopSearchParametersModalComponent',
    category: 'modal',
    description: "Shop search parameter modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "shop-search-parameters-modal",
    sharedFields: {}
  },

  () => ({
    display_asap_for_later_picker: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        "label": "Display ASAP/Later picker"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["display_asap_for_later_picker"],
          },
        ],
      },
    ],
  })
);

export function shopSearchParametersModalDescriptor(): IBlockDescriptor;
export function shopSearchParametersModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopSearchParametersModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopSearchParametersModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopSearchParametersModalDescriptor, shopSearchParametersModalProperties, fieldOrder);
}

export {
  shopSearchParametersModalModalDefinition,
  shopSearchParametersModalDashboardLayout,
  shopSearchParametersModalProperties,
  shopSearchParametersModalConfig,
  shopSearchParametersModalResolveConfig,
};

export type ShopSearchParametersModalConfig = typeof shopSearchParametersModalConfig;
